<template>
<div>
  <v-dialog
       v-model="dialogDeleteVacation"
      persistent
       width="700"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          CONFIRMACIÓN
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialogDeleteVacation=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              ¿Desea eliminar la vacación?
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <div class="text-xs-center">
                <v-btn color="error" @click="eliminarConfirmado()">
                    ACEPTAR
                  </v-btn>
              </div>
              </v-flex>
            <v-flex xs12 sm6 md6>
              <div class="text-xs-center">
                <v-btn  @click="cancelarEliminar()">
                    CANCELAR
                  </v-btn>
              </div>
              </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  <v-dialog
       v-model="dialogVacacion"
      persistent
       width="700"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          AGREGAR VACACIÓN
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialogVacacion=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-menu
                v-model="menu_fecha_desde"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_desde"
                    label="Fecha Desde"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_desde"
                  @input="menu_fecha_desde=false"
                  locale="es-mx">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-menu
                v-model="menu_fecha_hasta"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_hasta"
                    label="Fecha Hasta"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_hasta"
                  @input="menu_fecha_hasta=false"
                  locale="es-mx">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="descripcion"
                  label="Descripción"
                ></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <div class="text-xs-center">
                <v-btn color="primary" @click="addVacation">
                    Agregar
                  </v-btn>
              </div>
              </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Vacaciones</v-toolbar-title>
            <v-spacer/>
      <v-btn color="primary" @click="dialogVacacion=true">
        Agregar Vacación
      </v-btn>
  </v-toolbar>

  <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td  class="text-xs-left px-2">
            {{ props.item.vacacion_id }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.fecha_desde }}
          </td>
          <td   class="text-xs-left px-2">
            {{ props.item.fecha_hasta }}
          </td>
          <td  class="text-xs-left px-2">
            {{ props.item.descripcion }}
          </td>
          <v-btn outlined color="secondary" @click="eliminar(props.item.vacacion_id)">
              Eliminar
            </v-btn>
        </tr>
      </template>
    </v-data-table>
</div>
</template>

<script>
export default {
  name: 'vacaciones',
  data: () => ({
    dialogDeleteVacation: false,
    vacationToDelete: null,
    colaborador_id: null,
    menu_fecha_desde: false,
    fecha_desde: null,
    menu_fecha_hasta: false,
    fecha_hasta: null,
    descripcion: null,
    rowItems: [],
    pagination: {},
    totalItems: 0,
    loading: false,
    dialogVacacion: false,
    headers: [
      {
        text: 'ID', value: 'vacacion_id', sortable: false, class: 'px-2',
      },
      {
        text: 'FECHA DESDE', value: 'fecha_desde', sortable: false, class: 'px-2',
      },
      {
        text: 'FECHA HASTA', value: 'fecha_hasta', sortable: false, class: 'px-2',
      },
      {
        text: 'DESCRIPCIÓN', value: 'descripcion', sortable: false, class: 'px-2',
      },
      {
        text: 'ACCIONES', value: 'acciones', sortable: false, class: 'px-2',
      },
    ],
  }),
  created() {
  },
  methods: {
    back() {
      this.$router.back();
    },
    eliminarConfirmado() {
      this.dialogDeleteVacation = false;
      const data = {
        vacacion_id: this.vacationToDelete,
      };
      this.$store.dispatch('vacaciones/removeRhVacation', data)
        .then(() => {
          this.fetchVacations();
        });
    },
    eliminar(itemId) {
      this.vacationToDelete = itemId;
      this.dialogDeleteVacation = true;
    },
    cancelarEliminar() {
      this.vacationToDelete = null;
      this.dialogDeleteVacation = false;
    },
    addVacation() {
      this.loading = true;
      this.dialogVacacion = false;
      const formdata = {
        fecha_desde: this.fecha_desde,
        fecha_hasta: this.fecha_hasta,
        descripcion: this.descripcion,
        colaborador_id: this.$route.params.id,
      };
      this.$store.dispatch('vacaciones/addRhVacation', formdata)
        .then(() => {
          this.fecha_desde = null;
          this.fecha_hasta = null;
          this.descripcion = null;
          this.loading = false;
          this.fetchVacations();
        });
    },
    fetchVacations() {
      this.loading = true;
      const {
        sortBy, descending, page, rowsPerPage,
      } = this.pagination;

      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
        colaborador_id: this.$route.params.id,
      };
      this.$store.dispatch('vacaciones/fetchRhVacations', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.rowItems = data.vacaciones;
          this.loading = false;
        });
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchVacations();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
